import React from 'react'
import { SettingsWrapper } from '../components/common'

interface CreateUserTypeSettingsProps {}

export const CreateUserTypeSettings: React.FC<
  CreateUserTypeSettingsProps
> = () => {
  return <SettingsWrapper>NOT IMPLEMENTED</SettingsWrapper>
}
